import type { State } from '../index.js'
import type { VizScope } from './VisualizationSliceTypes.js'

export type ScopeLoaded = {
  /** The scope's own record: the order, or the project. */
  scope: boolean
  samples: boolean
  /** The orders the samples belong to; for an order scope, the order itself. */
  orders: boolean
}

const NOTHING: ScopeLoaded = { scope: false, samples: false, orders: false }

/**
 * Which of the workspace's inputs the store holds for this very scope. A field is only true for data
 * fetched for `scope.id`: another order's or project's data, left behind by the page the user came from,
 * never counts.
 */
export function selectScopeLoaded(s: typeof State, scope: VizScope | null | undefined): ScopeLoaded {
  if (!scope) return NOTHING
  if (scope.kind === 'order') {
    const order = s.order.order
    const orderLoaded = !!order && order !== 'LOADING' && order.id === scope.id
    return {
      scope: orderLoaded,
      samples: s.order.samplePoolsOrderId === scope.id && Array.isArray(s.order.samplePools),
      orders: orderLoaded
    }
  }
  const p = s.project
  return {
    scope: p.currentProject?.id === scope.id,
    samples: p.samplesProjectId === scope.id && Array.isArray(p.currentSamples) && !p.samplesLoading,
    orders: p.projectOrdersProjectId === scope.id && p.projectOrders !== 'LOADING'
  }
}
